import React, {Component} from 'react';
import {Modal} from "antd";

class PreviewModal extends Component {
  render() {
    const {visible, handleCancel, imageUrl, title} = this.props;
    
    return (
      <Modal
        title={title}
        visible={visible}
        onCancel={() => handleCancel()}
        footer={[
          <button key="cancel" className="btn btn-warning" onClick={() => handleCancel()}>Ok</button>,
        ]}
      >
        {imageUrl?.includes('.pdf') ? <embed
          src={imageUrl}
          type="application/pdf"
          height={"500"} width={'100%'}
        /> : <img src={imageUrl} alt={'Preview'} height={500} width={'100%'}/>
        }
      </Modal>
    );
  }
}

export default PreviewModal;